import { DashboardV2Filters, DashboardV2State } from './types'

export const initialFilters: DashboardV2Filters = {
  status: '',
  energy: '',
  creationFrom: '',
  creationTo: '',
  prestation: '',
  contractType: '',
  subscriptionId: '',
  zohoId: '',
  meterIdElectricity: '',
  meterIdGas: '',
  lastname: '',
  firstname: '',
  email: '',
  phone: '',
  userId: '',
  providerId: '',
  details: [],
  productType: '',
  productTypeInsurance: '',
  prestationInsurance: '',
  prestationEnergy: '',
}

export const initialState: DashboardV2State = {
  contracts: [],
  filters: initialFilters,
  pagination: {
    currentPage: 1,
    prevCursor: null,
    nextCursor: null,
  },
  isLoading: false,
  error: null,
  usersList: {},
  providersList: {},
  url: '',
  page: 1,
  currentContract: null,
}
